
import type { PropType } from 'vue'
import type { AppMessages } from '../../../models'
import { defineComponent } from 'vue'

import { UiTooltip } from '../../keen-ui'

export default defineComponent({
  name: 'EpbSwitch',
  components: {
    UiTooltip,
  },
  props: {
    value: Boolean,
    colored: Boolean,
    switchPosition: {
      // left & right
      type: String,
      default: 'left',
    },
    disabled: Boolean,
    messages: {
      type: Object as PropType<AppMessages['switch']>,
      required: true,
    },
  },
})
